<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <div>
                <span class="navbar-brand mb-0 h3 fw-bold text-nowrap me-auto align-items-center" v-if="payment">
                        <i class="fi fi-rr-assept-document d-inline-flex pe-2"></i>
                        <span>{{ payment?.sequence }}</span>
                    </span>
                <span class="navbar-brand mb-0 h3 fw-bold text-nowrap me-auto align-items-center"
                      v-else-if="!payment && formInvoice">
                        <i class="fi fi-rr-assept-document d-inline-flex pe-2"></i>
                        {{ trans('general.defaults.pay') }}: <span class="text-secondary">{{ formInvoice?.sequence }}</span>
                    </span>
                <span class="navbar-brand mb-0 h3 fw-bold text-nowrap me-auto align-items-center" v-else>
                        <i class="fi fi-rr-assept-document d-inline-flex pe-2"></i>
                        {{ trans('general.defaults.pay') }}
                    </span>
            </div>
        </template>
        <template #content>
            <form action="#" ref="addProductForm" class="pb-5" @submit.prevent="submit">
                <div class="mt-4" style="padding-bottom: 50px">
                    <FormErrorAlerts :errors="errors"></FormErrorAlerts>
                    <div class="fields">
                        <div class="row g-2 mb-2 justify-content-between">
                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                    <input required type="number" min="0" step="0.01" v-model="model.amount"
                                           class="form-control"
                                           id="paymentAmount"
                                           :disabled="!!payment || selectedInvoices.length > 0"
                                           :placeholder="trans('general.page.space_billing.payment.model.payment_amount')">
                                    <label for="paymentAmount">
                                        {{ trans('general.page.space_billing.payment.model.payment_amount') }}
                                        ({{model?.currency?.code}})
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                    <datepicker required class="form-control" v-model="model.date" id="paymentDate"
                                                :disabled="!!payment"
                                                :monday-first="true"
                                                :language="language()" format="dd-MM-yyyy"></datepicker>
                                    <label for="paymentDate">
                                        {{ trans('general.page.space_billing.payment.model.payment_date') }}
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating">
                                    <select class="form-select" v-model="model.method" id="paymentMethod"
                                            :aria-label="trans('general.page.space_billing.payment.model.payment_method')">
                                        <option value="bank_transfer" selected>
                                            {{ trans('general.page.space_billing.payment.payment_method.bank_transfer') }}
                                        </option>
                                        <option value="cash">
                                            {{ trans('general.page.space_billing.payment.payment_method.cash') }}
                                        </option>
                                    </select>
                                    <label for="paymentMethod">
                                        {{ trans('general.page.space_billing.payment.model.payment_method') }}</label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating" v-if="model.method === 'bank_transfer'">
                                    <input type="text" v-model="model.creditedAccount" class="form-control"
                                           id="creditedAccount"
                                           :placeholder="trans('general.page.space_billing.payment.model.credited_account')">
                                    <label for="creditedAccount">
                                        {{ trans('general.page.space_billing.payment.model.credited_account') }}
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 mb-2">
                                <div class="form-floating">
                            <textarea v-model="model.note" class="form-control" id="productNote"
                                      :placeholder="trans('general.page.space_billing.payment.model.note')"></textarea>
                                    <label for="productNote">
                                        {{ trans('general.page.space_billing.payment.model.note') }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 mb-2">
                                <input ref="filesSelect" class="d-none" id="chooseFiles" type="file"
                                       accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                       v-on:change="selectedFiles($event)" multiple/>
                                <div class="card p-1 px-2">
                                    <div>
                                        <div class="d-flex hov-pointer" v-if="payment?.id">
                                            <div class="fs-12 mb-1 cursor alias text-decoration-none"
                                                 @click="openDocumentsPanel('tabAttachments')">
                                                <i class="fi fi-rr-clip"></i>
                                                <span
                                                    class="table-hover">{{ trans('general.page.space_billing.payment.attachments') }} </span>
                                                <span class="text-secondary"
                                                      v-if="totalDocuments"> ({{totalDocuments}})</span>
                                                <i class="fi fi-rr-arrow-alt-right"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex w-100 justify-content-between  gap-2 ">
                                            <div class="card border-dark p-2 w-100 text-center fs-12 hov-pointer"
                                                 v-if="files.length < 1"
                                                 @click="() => $refs.filesSelect.click()"
                                                 style="border: dashed 2px #3c3c3c">
                                                <i class="fi fi-rr-upload"></i>
                                                <span>{{ trans('general.page.space_billing.payment.messages.click_to_upload') }}</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="files.length > 0" class="mt-2 text-center">
                                        <div v-for="(file, index) in files"
                                             class="d-flex justify-content-between w-100 p-2 me-2 mb-2 bg-gray-100 rounded-3 cursor help"
                                             :title="trans('general.page.space_billing.invoice.messages.click_save_to_upload')"
                                        >
                                            <div class="d-flex align-items-center text-primary  ">
                                                <div class="max-w-50 me-2 "><i class="fi fi-rr-document"></i></div>
                                                <div class="name">{{ file.name }}</div>
                                            </div>
                                            <div class="actions">
                                                <button type="button" class="btn btn-circle btn-sm btn-delete btn-secondary "
                                                        v-on:click="files.splice(index, 1)">
                                                    <i class="fi fi-rr-cross"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <button v-if="payment" type="button" @click="uploadDocuments"
                                                class="btn btn-upload btn-secondary  btn-icon-split gap-2 mt-2 text-center align-items-center">
                                            {{ trans('general.defaults.upload') }}
                                            <waiting-indicator-icon :name="SUBMIT_INDICATOR"
                                                                    color="success"
                                                                    icon="fi-rr-cloud-upload"></waiting-indicator-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="items" v-if="payment">
                        <div class="row">
                            <div class="h6 mt-4 text-dark fw-bold justify-content-between  d-flex">
                                {{ trans('general.page.space_billing.payment.paid_invoices') }}:
                            </div>
                            <div class="col-12 ">
                                <payable-invoices-list :payment="payment"></payable-invoices-list>
                            </div>
                        </div>
                    </div>

                    <div class="items" v-if="!invoice && model.amount > 0 && (!payment || payment?.unspent_amount > 0)">
                        <hr>
                        <div class="row">
                            <div class="h5 mt-4 text-dark fw-bold justify-content-between  d-flex">
                                {{
                                    payment ? trans('general.page.space_billing.payment.pay_with_remaining') : trans('general.page.space_billing.payment.pay_invoices')
                                }}:
                                <span class="text-success">{{
                                        getCurrency(invoice)
                                    }} {{ round(payableAmount - (usedAmount / 100), 2).toFixed(2) }}</span>
                            </div>
                            <div class="col-12 col-lg-6 mb-2">
                                <child-form-select v-model="child" :disabled="!!child && !!payment" background="form-control"
                                                   :placeholder="trans('general.page.space_billing.payment.model.child')"
                                                   :label="trans('general.page.space_billing.payment.model.child')"/>
                            </div>
                            <div class="col-12 " v-if="child">
                                <payable-invoices-list v-on:selected-invoices="onInvoiceSelected"
                                                       :payable-amount="Number(payableAmount)"
                                                       :child="child"/>
                            </div>
                        </div>
                    </div>
                </div>
                <nav class="position-fixed nav navbar-light bg-gray-100 bottom-0 right-0  px-4"
                     style="max-width: 576px; width: 100%">
                    <div class="d-flex w-100 gap-2 py-1 justify-content-end">
                        <button class="btn btn-submit btn-primary btn-icon-split" type="submit"
                                v-if="!payment || (payment && payment.unspent_amount)">
                            <span class="text">{{ trans('general.defaults.pay') }}</span>
                            <waiting-indicator-icon :name="SUBMIT_INDICATOR" color="success"
                                                    icon="fi-rr-receipt"></waiting-indicator-icon>
                        </button>
                    </div>
                </nav>
            </form>
        </template>
    </slideout-content>
</template>

<script>
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts.vue";
import CurrencySelect from "../../../theme/atoms/CurrencySelect.vue";
import {datePickerLanguage} from "../../../services/CalendarLocaleSQ";
import {round} from "../../../services/MathFunctions";
import datepicker from "vuejs-datepicker";
import {EMIT_INVOICE_PAID, getSpaceCurrency} from "../../../services/SpaceBillingContants";
import moment from "moment";
import InvoiceItems from "./InvoiceItems.vue";
import PayableInvoicesList from "./PayableInvoicesList.vue";
import ChildFormSelect from "../../../theme/atoms/ChildFormSelect.vue";
import {INVOICE_SUBMISSION_INDICATOR} from "../organisms/InvoiceForm/InvoiceForm";
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon.vue";
import SlideoutContent from "../../../theme/molecules/SlideoutContent.vue";

export const SUBMIT_INDICATOR = 'SUBMIT_INDICATOR'

export default {
    name: "PaymentForm",
    props: {
        invoice: {
            type: Object
        },
        payment: {
            type: Object
        }
    },
    components: {
        SlideoutContent,
        ChildFormSelect,
        InvoiceItems,
        FormErrorAlerts,
        CurrencySelect,
        datepicker,
        PayableInvoicesList,
        WaitingIndicatorIcon
    },
    data() {
        return {
            SUBMIT_INDICATOR,
            errors: [],
            formInvoice: this.invoice,
            child: null,
            model: {
                amount: (this.invoice?.open_balance ?? this.invoice?.amount ?? 0) / 100,
                currency: null,
                date: new Date(),
                method: 'bank_transfer',
                creditedAccount: null,
                note: null,
            },
            selectedInvoices: [],
            files: [],
            usedAmount: 0,
            totalDocuments: 0
        }
    },
    computed: {
        payableAmount() {
            return this.payment
                ? (this.payment.unspent_amount ? this.payment.unspent_amount : this.payment.payment_amount) / 100
                : this.model.amount;
        }
    },

    methods: {
        language: datePickerLanguage,
        round: round,
        getCurrency() {
            return this.model?.currency?.symbol ?? ' '
        },
        submit(event) {
            event.preventDefault();
            this.$wait.start(SUBMIT_INDICATOR);
            const url = this.payment ? `/space/billing/payments/${this.payment.id}` : '/space/billing/payments/new'

            axios.post(url, this.getPostData(), {headers: {'content-type': 'multipart/form-data'}}).then(response => {
                this.$wait.end(SUBMIT_INDICATOR);
                this.$emit(EMIT_INVOICE_PAID, response.data.data)
                this.$emit('closePanel', response.data.data);
                this.$notify({type: 'success', text: trans('general.page.space_billing.payment.messages.payment_created')});
            }).catch((error) => {
                this.$wait.end(SUBMIT_INDICATOR);
                if (error.response.data.message === '' && error.response.data.errors) {
                    let errors = Object.values(error.response.data.errors);
                    this.errors = errors.map(val => val[0] || 0)
                } else {
                    this.$notify({type: 'error', text: error.response.data.message});
                }
            });
        },

        getPostData() {
            const {amount, date, method, note, creditedAccount, currency} = this.model;

            const form = new FormData();
            if (method) form.append('payment_method', method);
            if (creditedAccount) form.append('credited_account', creditedAccount);
            if (note) form.append('note', note);

            if (!this.payment) {
                if (amount) form.append('payment_amount', amount * 100);
                if (currency) form.append('currency_code', currency.code);
                if (date) form.append('payment_date', moment(date).format('YYYY-MM-DD'));
            }

            this.files.forEach(file => {
                form.append('files_names[]', file.name)
                form.append('files[]', file)
            });

            const invoices = this.invoice
                ? [{invoice_id: this.invoice.id, amount_paid: amount * 100}]
                : this.selectedInvoices;

            invoices.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    form.append(`invoices[${index}][${key}]`, item[key])
                })
            });

            return form;
        },

        closePanel(event) {
            event.preventDefault()
            this.$emit('closePanel', {});
        },

        initPaymentForm() {
            if (this.payment) {
                this.totalDocuments = this.payment.documents_count;
                const {
                    payment_amount,
                    payment_date,
                    payment_method,
                    note,
                    credited_account,
                    currency_code,
                    child
                } = this.payment;
                this.child = child;

                this.model = {
                    amount: payment_amount / 100,
                    currency: {code: currency_code},
                    date: payment_date,
                    method: payment_method,
                    creditedAccount: credited_account,
                    note: note,
                }
            }
        },
        onInvoiceSelected(selectedInvoices) {
            let amountUsed = 0;
            selectedInvoices.forEach(invoice => amountUsed = amountUsed + invoice.amount_paid);

            this.usedAmount = amountUsed;
            this.selectedInvoices = selectedInvoices;
        },
        selectedFiles(event) {
            for (let file of event.target.files) {
                this.files.push(file)
            }
        },
        uploadDocuments() {
            this.$wait.start(SUBMIT_INDICATOR);
            const form = new FormData();
            this.files.forEach(file => {
                form.append('files_names[]', file.name)
                form.append('files[]', file);
            });
            axios.post(`/space/billing/payments/${this.payment.id}/upload-documents`,
                form, {headers: {'content-type': 'multipart/form-data'}})
                .then(response => {
                    this.totalDocuments = response.data.data.total;
                    this.files = [];
                    this.$wait.end(SUBMIT_INDICATOR);
                })
                .catch((error) => {
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                    this.$wait.end(SUBMIT_INDICATOR);
                });
        },
        openDocumentsPanel(activeTab) {
            this.$showPanel({
                component: 'payment-documentation-panel',
                openOn: 'right',
                width: 576,
                disableBgClick: false,
                cssClass: 'sidePanel',
                props: {
                    paymentId: this.payment.id,
                    activeTab: activeTab ?? 'tabInvoices'
                }
            }).promise.then(({totalDocuments}) => this.totalDocuments = totalDocuments);
        },
    },
    mounted() {
        this.initPaymentForm();
        getSpaceCurrency().then(currency => this.model.currency = currency)
    }
}
</script>

<style scoped>
#productNote {
    min-height: 100px;
}
</style>
